import apiClient from './Api';
const PREFIX = '/common';

const imageDataGetFromUrl = url => {
  return apiClient({
    url: url,
    method: 'GET',
    responseType: 'blob'
  });
};

const shareFeedback = postData => {
  return apiClient({
    url: `${PREFIX}/sharefeedback`,
    method: 'POST',
    data: postData
  });
};

const manualUpload = (postData, uploadProgress, cancelToken) => {
  return apiClient({
    url: `${PREFIX}/processmavis`,
    method: 'POST',
    data: postData,
    onUploadProgress: uploadProgress,
    cancelToken: cancelToken
  });
};

const getVeehileBodyType = () => {
  return apiClient({
    url: `${PREFIX}/btypes`,
    method: 'GET'
  });
};

const getTrack = postData => {
  return apiClient({
    url: `${PREFIX}/edittrack`,
    method: 'POST',
    data: postData
  });
};

const getEditorQueue = postData => {
  return apiClient({
    url: `${PREFIX}/editorqueue`,
    method: 'POST',
    data: postData
    // , params: postData ? postData : { offset: 0 }
  });
};

const getEditorMatrixData = postData => {
  return apiClient({
    url: `${PREFIX}/editormatrixdata`,
    method: 'POST',
    data: postData
  });
};

const getPublishedImageYTD = () => {
  return apiClient({
    url: `${PREFIX}/publishedYTDImage`,
    method: 'GET'
  });
};

const saveBodyType = postData => {
  return apiClient({
    url: `${PREFIX}/savebtype`,
    method: 'POST',
    data: postData
  });
};

const deleteBodyType = postData => {
  return apiClient({
    url: `${PREFIX}/delbtype`,
    method: 'POST',
    data: postData
  });
};

const inventoryGalleryReorder = postData => {
  return apiClient({
    url: `${PREFIX}/rearrange`,
    method: 'POST',
    data: postData
  });
};

const galleryDeleteImage = postData => {
  return apiClient({
    url: `${PREFIX}/disdelete`,
    method: 'POST',
    data: postData
  });
};

const galleryUploadImage = postData => {
  return apiClient({
    url: `${PREFIX}/libnew`,
    method: 'POST',
    data: postData
  });
};

const galleryImageDownload = postData => {
  return apiClient({
    url: `${PREFIX}/gadownload`,
    method: 'POST',
    data: postData
  });
};

const galleryImageReplaceOnDrop = postData => {
  return apiClient({
    url: `${PREFIX}/libreplace`,
    method: 'POST',
    data: postData
  });
};

const userIsAlreadyEditing = () => {
  return apiClient({
    url: `${PREFIX}/vehicleisalreadyediting`,
    method: 'GET'
  });
};

const clearEditingQueue = postData => {
  return apiClient({
    url: `${PREFIX}/cleareditingqueue`,
    method: 'POST',
    data: postData
  });
};

const deleteEditorImage = postData => {
  return apiClient({
    url: `${PREFIX}/deletephoto`,
    method: 'POST',
    data: postData
  });
};

const deleteVehicle = postData => {
  return apiClient({
    url: `${PREFIX}/deletevehicle`,
    method: 'POST',
    data: postData
  });
};

// const checkIsUseNewMavisModal = () => {
//   return apiClient({
//     url: `${PREFIX}/checkisusenewmavismodal`,
//     method: 'GET'
//   });
// };

const getEditingMetrics = postData => {
  return apiClient({
    url: `${PREFIX}/geteditingmetrics`,
    method: 'POST',
    data: postData
  });
};

const sendToEditingQueue = postData => {
  return apiClient({
    url: `${PREFIX}/sendtoeditingqueue`,
    method: 'POST',
    data: postData
  });
};

const sendTrainingRequest = postData => {
  return apiClient({
    url: `${PREFIX}/trainingrequest`,
    method: 'POST',
    data: postData
  });
};

const sendInstantPhotoReport = postData => {
  return apiClient({
    url: `${PREFIX}/send-photo-report`,
    method: 'POST',
    data: postData
  });
};

const sendInstantImportReport = postData => {
  return apiClient({
    url: `${PREFIX}/send-import-report`,
    method: 'POST',
    data: postData
  });
};
const getCurrentReprocess = postData => {
  return apiClient({
    url: `${PREFIX}/getcurrentreprocess`,
    method: 'POST',
    data: postData
  });
};

const getEditQueueVehicle = postData => {
  return apiClient({
    url: `${PREFIX}/queue-vehicles`,
    method: 'POST',
    data: postData
  });
};

const CommonService = {
  shareFeedback,
  imageDataGetFromUrl,
  manualUpload,
  getVeehileBodyType,
  getTrack,
  getPublishedImageYTD,
  saveBodyType,
  deleteBodyType,
  inventoryGalleryReorder,
  galleryDeleteImage,
  galleryUploadImage,
  galleryImageDownload,
  galleryImageReplaceOnDrop,
  getEditorQueue,
  getEditorMatrixData,
  userIsAlreadyEditing,
  clearEditingQueue,
  deleteVehicle,
  deleteEditorImage,
  // checkIsUseNewMavisModal,
  getEditingMetrics,
  sendToEditingQueue,
  sendTrainingRequest,
  sendInstantPhotoReport,
  sendInstantImportReport,
  getCurrentReprocess,
  getEditQueueVehicle
};

export default CommonService;
